import { carouselItems } from '@/mocks/homeData';

const carouselImages = [
  'https://readdy.ai/api/search-image?query=Editorial%20news%20illustration%20dramatic%20moody%20atmosphere%20with%20warm%20dark%20crimson%20and%20charcoal%20tones%2C%20breaking%20news%20concept%2C%20abstract%20document%20and%20investigation%20visual%20metaphor%2C%20modern%20editorial%20design%2C%20cinematic%20lighting%2C%20no%20readable%20text&width=800&height=450&seq=carousel-1-2026&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20mysterious%20dark%20toned%20editorial%20illustration%20showing%20two%20corporate%20shadows%20in%20conflict%2C%20warm%20crimson%20accents%2C%20dramatic%20contrast%2C%20abstract%20business%20warfare%20concept%2C%20cinematic%20composition%2C%20no%20readable%20text&width=800&height=450&seq=carousel-2-2026&orientation=landscape',
  'https://readdy.ai/api/search-image?query=A%20stylized%20digital%20algorithm%20concept%20illustration%20with%20abstract%20data%20streams%20and%20hidden%20patterns%2C%20warm%20crimson%20and%20charcoal%20palette%2C%20modern%20tech%20editorial%20aesthetic%2C%20dramatic%20lighting%2C%20no%20readable%20text&width=800&height=450&seq=carousel-3-2026&orientation=landscape',
  'https://readdy.ai/api/search-image?query=An%20abstract%20legal%20document%20and%20contract%20concept%20illustration%2C%20dramatic%20shadows%20and%20warm%20crimson%20highlights%2C%20investigative%20journalism%20aesthetic%2C%20dark%20moody%20atmosphere%2C%20editorial%20design%20quality%2C%20no%20readable%20text&width=800&height=450&seq=carousel-4-2026&orientation=landscape',
];

const tagStyles: Record<string, string> = {
  '独家': 'bg-primary-100 text-primary-700',
  '深度': 'bg-accent-100 text-accent-700',
  '揭秘': 'bg-secondary-100 text-secondary-700',
  '重磅': 'bg-primary-500 text-background-50',
};

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-flashlight-line"></i>
            编辑精选
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">焦点专题</h2>
          <p className="text-foreground-600 text-sm">深度挖掘，还原事件全貌</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl overflow-hidden border border-secondary-200/70 hover:border-primary-200 transition-all duration-300 group cursor-pointer"
            >
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={carouselImages[i]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                    if (t.parentElement) t.parentElement.style.backgroundColor = 'oklch(0.87 0.052 25)';
                  }}
                />
                <span className={`absolute top-3 left-3 text-xs px-2.5 py-1 rounded-full font-medium ${tagStyles[item.tag] || 'bg-secondary-100 text-secondary-700'}`}>
                  {item.tag}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2 font-heading group-hover:text-primary-600 transition-colors leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-3">{item.excerpt}</p>
                <span className="text-xs text-foreground-400">{item.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}